// extracted by mini-css-extract-plugin
export var resume = "resume-module--resume--NGAKB";